import moment from 'moment'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import AuditView from '@/components/Audit'
import Page from '@/components/Page'
import { USER_ATTRIBUTES } from '@/components/User'
import { fetchUsersPaginated, resetRequest } from '@/store/actions'
import { isRequestError, isRequestPending } from '@/store/selectors'

import { aggregateAuditEvents, fetchAuditLogs } from './actions'
import { AGGREGATE_AUDIT_EVENTS, FETCH_AUDIT_LOGS, FETCH_AUDIT_SEARCH_USERS } from './actionTypes'
import messages from './messages'
import { getAuditOffset, getAuditTotalCount, getEvents, getLogs, getSearchedUsersInOrg } from './selectors'

const errorsToHandle = [
  { type: FETCH_AUDIT_LOGS, data: { detailCode: 'OAPFAL' } },
  { type: AGGREGATE_AUDIT_EVENTS, data: { detailCode: 'OAPAAE' } }
]

function OrganizationAuditPage(props: any) {
  // componentDidMount
  useEffect(() => {
    props.actions.aggregateAuditEvents()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // componentWillUnmount
  useEffect(() => {
    return () => {
      props.actions.resetRequest([FETCH_AUDIT_SEARCH_USERS, AGGREGATE_AUDIT_EVENTS, FETCH_AUDIT_LOGS])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const searchLogs = (params: any) => {
    const searchParams = { ...params }
    searchParams.oldest = moment(searchParams.oldest).toISOString()
    searchParams.latest = moment(searchParams.latest).toISOString()
    props.actions.fetchAuditLogs(searchParams)
  }

  const searchUsers = (filter: any) => {
    const query: { attributes: string[]; count: number; filter?: string } = {
      attributes: USER_ATTRIBUTES,
      count: 10
    }

    if (filter) {
      query.filter = USER_ATTRIBUTES.map(attribute => `${attribute} co ${JSON.stringify(filter)}`).join(' or ')
    }

    props.actions.fetchUsersPaginated(query, FETCH_AUDIT_SEARCH_USERS)
  }

  const { offset, auditTotalCount, events, isActionInProgress, isSearching, logs, users } = props
  return (
    <Page className="organization-Audit-wrapper" errorsToHandle={errorsToHandle}>
      <Page.Header
        title={<FormattedMessage {...messages.title} />}
        buttons={
          <div className="flex h-full items-center">
            <Link to="/organization/audit/api">Audit API Management</Link>
          </div>
        }
      />
      <AuditView
        offset={offset}
        auditTotalCount={auditTotalCount}
        events={events}
        logs={logs}
        isActionInProgress={isActionInProgress}
        isSearching={isSearching}
        perPage={20}
        searchLogs={searchLogs}
        searchUsers={searchUsers}
        users={users.sort((a: any, b: any) => a.email.localeCompare(b.email))}
      />
    </Page>
  )
}

export { /** @deprecated */ OrganizationAuditPage }

function mapStateToProps(state: any) {
  return {
    logs: getLogs(state),
    auditTotalCount: getAuditTotalCount(state),
    offset: getAuditOffset(state),
    hasError: isRequestError(state, [FETCH_AUDIT_LOGS, AGGREGATE_AUDIT_EVENTS]),
    isActionInProgress: isRequestPending(state, [FETCH_AUDIT_LOGS, AGGREGATE_AUDIT_EVENTS]),
    events: getEvents(state),
    users: getSearchedUsersInOrg(state),
    isSearching: isRequestPending(state, FETCH_AUDIT_SEARCH_USERS)
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(
      {
        fetchAuditLogs,
        fetchUsersPaginated,
        aggregateAuditEvents,
        resetRequest
      },
      dispatch
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationAuditPage)
